module.exports = __webpack_public_path__ + "img/GapWidening.b5ca7b62.png";